import { cn } from '@/utils/tailwind.util';
export const InlineTooltipContainer = ({
  className,
  children
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <div onMouseDown={e => {
    e.preventDefault();
    e.stopPropagation();
  }} className={cn('border-border-alternative z-20 w-fit items-center rounded-[10px] px-2xs py-3xs shadow-sm flex', 'duration-200 animate-in fade-in', className)} data-sentry-component="InlineTooltipContainer" data-sentry-source-file="InlineTooltipContainer.tsx">
      {children}
    </div>;
};